import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import CustomAvatar from './../../../common/Avatar/Avatar';
import Breadcrumb from './../../../common/Breadcrumb/Breadcrumb';

const BatchDetails = ({ batchDetails, links, partLength }) => (
	<div className='BatchDetails detailed-view'>
		<CustomAvatar name={batchDetails.name} />
		<div className="details">
			<div className="row detailed-card">
				<div className="col-8 card-heading">
					<div className="heading">
						<div className="title">{batchDetails.name}</div>
						<div className="desc">{batchDetails.description}</div>
					</div>
				</div>
				<div className="col bread-crumb">
					<Breadcrumb links={links} />
				</div>
			</div>
			<div className="row card-details">
				<div className="col-4 col-md-4 col-lg ">
					<div className="title">course name</div>
					<div className="value">{batchDetails.course_name}</div>
				</div>
				{partLength > 0 && <div className="col col-md-4 col-lg">
					<div className="title"># of Participants</div>
					<div className="value">{partLength}</div>
				</div>}
				<div className="col-4 col-md-4 col-lg">
					<div className="title">location</div>
					<div className="value">{batchDetails.city}, {batchDetails.country}</div>
				</div>
				<div className="col-4 col-md-4 col-lg">
					<div className="title">date</div>
					<div className="value">

						{moment(batchDetails.start_date).format('DD MMM YYYY')}&nbsp;-&nbsp;

						{moment(batchDetails.end_date).format('DD MMM YYYY')}
					</div>
				</div>
			</div>
		</div>
	</div>
);

BatchDetails.propTypes = {
	batchDetails: PropTypes.instanceOf(Object),
	links: PropTypes.instanceOf(Array),
	partLength: PropTypes.number
};

BatchDetails.defaultProps = {
	batchDetails: {},
	links: [],
	partLength: 0
};

export default BatchDetails;


// WEBPACK FOOTER //
// ./components/BatchParticipant/BatchDetails/BatchDetails.js